import React from "react";

const CarouselContent = ({children}) => {
  return <>{children}</>;
};

export default CarouselContent;
